const KEY = "ks_notif_prefs";

export function loadNotifPrefs() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || { hires: true, bookings: true };
  } catch { return { hires: true, bookings: true }; }
}

export function saveNotifPrefs(prefs) {
  localStorage.setItem(KEY, JSON.stringify(prefs));
}

export function shouldNotify(kind) {
  const p = loadNotifPrefs();
  return !!p[kind];
}
